import { useRole } from '@/hooks/use-role';

/**
 * Who may open Products > Base garments: `skus.manage` (Admin, Super Admin and
 * the Warehouse Coordinator). Reads only what is already loaded, so it costs
 * no call.
 *
 * The ONE check for the view switch's option and the view itself, so they can
 * never disagree. The four layers: this (the switch and the view's quiet
 * line), the router's RoleGuard, the `baseGarments` router's
 * `requirePermission(SkusManage)` middleware, and the same check as the first
 * line of every handler. Cost fields and the supplier need `skus.costs_manage`
 * on top; stock edits need `inventory.write` (both read where they are drawn).
 */
export function useBaseGarmentsAccess(): boolean {
  const { can } = useRole();
  return can('skus.manage');
}
